export default "__VITE_ASSET__VLqcUuGa__"